export default __webpack_public_path__ + "static/media/calendar-date.47ee2f93.svg";